// Converte a data em uma string que contém apenas letras minúsculas e hífens
function dateToAlphaString() {
  // Obtem a data atual em formato ISO
  const date = new Date().toISOString().split('T')[0]; // Por exemplo: "2023-04-17"
  
  // Converte a data em um formato apenas com letras
  // Substitui números por letras correspondentes (1=a, 2=b, etc.)
  const alphaDate = date.replace(/[0-9]/g, (d) => 
    String.fromCharCode(96 + parseInt(d, 10) + 1)
  );
  
  // Substitui qualquer caractere não alfabético por hífens
  return alphaDate.replace(/[^a-z]/g, '-');
}

// Gera uma chave válida para o Emotion (apenas letras minúsculas e hífens)
export const CACHE_KEY = `mnl-${dateToAlphaString()}`;
